var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
define(["require", "exports", "api/v2/persisted", "underscore", "backbone"], function (require, exports, persisted_1, underscore_1, backbone_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.PersistedAppFragmentStore = void 0;
    persisted_1 = __importDefault(persisted_1);
    underscore_1 = __importDefault(underscore_1);
    backbone_1 = __importDefault(backbone_1);
    class PersistedAppFragmentStore {
        constructor(options) {
            this.options = underscore_1.default.extend({ collectionName: "default" }, options);
        }
        get(id) {
            throw new Error("Method not implemented.");
        }
        getCollectionName(application) {
            var _a, _b;
            return ((_b = (_a = application === null || application === void 0 ? void 0 : application.options) === null || _a === void 0 ? void 0 : _a.experiementalPersistedResourcesAppFragmentStoreCollection) !== null && _b !== void 0 ? _b : "default");
        }
        // TODO remove this as soon as the aisummit app fragments data are stored as not encoded
        ensureDataNotDecoded(data) {
            // URIError: malformed URI sequence
            // in case the styles include the % it will stop decoding data
            try {
                if (decodeURI(data) === data)
                    return data;
                return decodeURI(data);
            }
            catch (error) {
                return data;
            }
        }
        toAppFragment(model) {
            const properties = model.get("properties");
            const data = this.ensureDataNotDecoded(model.get("data"));
            const dataJSON = JSON.parse(data);
            return {
                id: model.get("id"),
                type: properties.type,
                name: properties.name,
                version: properties.version,
                title: properties.title,
                htmlFragment: dataJSON.htmlFragment,
                description: dataJSON.description,
                schema: dataJSON.schema,
                storeProperties: {
                    storeId: this.getStoreId(),
                    writeable: this.isWriteable()
                }
            };
        }
        getStoreId() {
            return "persistedAppFragmentStore";
        }
        isWriteable() {
            return true;
        }
        removeById(id, options) {
            const that = this;
            const persisted = new persisted_1.default({
                channels: options.application.models.channels,
            });
            const path = ["appfragment", that.getCollectionName(options.application)];
            const collection = persisted.resources(path);
            return new Promise((resolve, reject) => {
                const observer = underscore_1.default.extend({}, backbone_1.default.Events);
                const request = { remove: { id: id, path: id.split("/") } };
                observer.on("response", (response) => {
                    resolve(response);
                });
                observer.on("error", (response) => {
                    reject(response);
                });
                collection.serviceStub.cast(collection.channels, request, observer);
            });
        }
        getByTypeAndName(appType, appName, options) {
            return this.findFirstByTypeAndNames(appType, [appName], options);
        }
        findFirstByTypeAndNames(appType, appNames, options) {
            const getAppFragmentFromList = () => {
                var _a;
                var appfragment;
                for (let appName of appNames) {
                    appfragment = (_a = this.list) === null || _a === void 0 ? void 0 : _a.find((fragment) => fragment.name === appName && fragment.type === appType);
                    if (appfragment)
                        return appfragment;
                }
                return null;
            };
            if (!this.list) {
                return new Promise((res, rej) => {
                    this.getAllAppDescriptions(undefined, options)
                        .then(() => {
                        const templateElement = getAppFragmentFromList();
                        if (!templateElement) {
                            rej();
                        }
                        else {
                            res(templateElement);
                        }
                    })
                        .catch((error) => {
                        console.warn("Failed to fetch modules", error);
                        rej();
                    });
                });
            }
            return new Promise(function (resolve, reject) {
                const templateElement = getAppFragmentFromList();
                if (!templateElement) {
                    reject();
                }
                else {
                    resolve(templateElement);
                }
            });
        }
        getAllAppDescriptions(appType, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const that = this;
                return new Promise(function (res, rej) {
                    const persisted = new persisted_1.default({
                        channels: options.application.models.channels,
                    });
                    const appfragmentCollection = persisted.resources([
                        "appfragment",
                        that.getCollectionName(options.application),
                    ]);
                    appfragmentCollection.fetch({
                        success: underscore_1.default.bind((response) => {
                            if (response.status && response.status.success === false) {
                                return res([]);
                            }
                            const mapped = underscore_1.default.map(response.models, (model) => {
                                return that.toAppFragment(model);
                            });
                            that.list = mapped;
                            res(mapped);
                        }, that),
                    });
                });
            });
        }
        create(appFragment, options) {
            const that = this;
            return new Promise(function (res, rej) {
                var _a, _b;
                const persisted = new persisted_1.default({
                    channels: options.application.models.channels,
                });
                const appfragmentCollection = persisted.resources([
                    "appfragment",
                    options.persistedResourcesAppFragmentStoreCollection ||
                        that.getCollectionName(options.application),
                ]);
                const properties = {
                    title: (_a = appFragment.title) !== null && _a !== void 0 ? _a : appFragment.name,
                    type: appFragment.type,
                    version: (_b = appFragment.version) !== null && _b !== void 0 ? _b : "v1",
                    name: appFragment.name,
                };
                delete appFragment.storeProperties;
                // @todo appfragmentCollection.create triggers API request twice.
                appfragmentCollection.add({
                    properties: properties,
                    data: JSON.stringify(appFragment),
                }, {
                    success: underscore_1.default.bind((response) => {
                        res(that.toAppFragment(response));
                    }, that),
                });
            });
        }
        save(appFragment, options) {
            const that = this;
            return new Promise(function (res, rej) {
                var _a, _b, _c;
                const persisted = new persisted_1.default({
                    channels: options.application.models.channels,
                });
                const appfragmentCollection = persisted.resources([
                    "appfragment",
                    options.persistedResourcesAppFragmentStoreCollection ||
                        that.getCollectionName(options.application),
                ]);
                const properties = {
                    title: (_a = appFragment.title) !== null && _a !== void 0 ? _a : appFragment.name,
                    type: appFragment.type,
                    version: (_b = appFragment.version) !== null && _b !== void 0 ? _b : "v1",
                    name: appFragment.name,
                };
                delete appFragment.storeProperties;
                appfragmentCollection.update({
                    path: (_c = appFragment.id) === null || _c === void 0 ? void 0 : _c.split("/"),
                    id: appFragment.id,
                    properties: properties,
                    data: JSON.stringify(appFragment),
                }, {
                    success: underscore_1.default.bind((response) => {
                        res(that.toAppFragment(response));
                    }, that),
                });
            });
            return Promise.resolve({});
        }
    }
    exports.PersistedAppFragmentStore = PersistedAppFragmentStore;
});
